export const studentCard = {
  title: 'Match Summary',
  subtitle: 'Your match details',
  victory: 'Victory!',
  goodTry: 'Good Try',
  matchDetails: 'Match Details',
  opponent: 'Opponent',
  location: 'Location',
  date: 'Date',
  setScores: 'Set Scores',
  set: 'Set',
  finalScore: 'Final Score',
  shareMatch: 'Share Match',
  logAnotherMatch: 'Log Another Match',
  matchResultCopied: 'Match details copied to clipboard!',
};
